import axios from 'axios';

export default {
  fetchTraineeList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/training/trainee', {
      params: paginationParams,
    })
      .then((trainees) => {
        commit('setData', trainees);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  downloadCsv(_, params) {
    return axios.post('/training/trainee', params);
  },
};
